import Help from "../../../misc/Help";
import Field from "../fields/Field";
import { Icons } from "../../../misc/Icons";
import { DisplayDictionary } from "../../..";
import { Button, IconButton } from "@mui/material"
import { FormFieldOutput } from "../../../models/Interfaces";
import { addDays, differenceInDays, format, isValid, subDays } from "date-fns";
import { UTCDate } from "@date-fns/utc";
import { Theme } from "../../../misc/Theme";


export default function AbsenceTable ({periodStart, periodEnd, rows, onChange = (newRows) => {}}) {

    const removeAbsence = (index: number) => {
        onChange([...rows.filter((row, r) => r !== index)])
    }

    const addAbsence = () => {
        onChange(
            [
                ...rows, 
                {
                    FromDate: null,
                    ToDate: null,
                    Purpose: "",
                    CountriesVisited: [],
                    Certainty: "CERTAIN",
                }
            ]
        )
    }

    const handleAbsenceChange = (rowIndex: number, fieldOutput: FormFieldOutput) => {
        var table = [...rows]
        table[rowIndex][fieldOutput.name] = fieldOutput.value
        onChange(table)
    }

    var shiftDays = true

    return (
        <div>
            <table style={{width: "99%"}}>
                <thead>
                    <tr>
                        <td></td>
                        <td>{shiftDays ? "Departed" : "From"}</td>
                        <td>{shiftDays ? "Returned" : "To"}</td>
                        <td>Absent</td>
                        <td>Purpose</td>
                        <td>Country</td>
                        <td>Certainty</td>
                        <td></td>
                    </tr>
                </thead>

                <tbody>
                    {rows.map((rowData: any, index: number) => {

                        var fromDate = rowData.FromDate
                        var toDate = rowData.ToDate
                        var daysCount = ""

                        if (!!fromDate && !!toDate && isValid(fromDate) && isValid(toDate)) {
                            var daysCountInt = differenceInDays(toDate, fromDate)
                            if (daysCountInt > 0 && daysCountInt < 1000) {
                                daysCount = daysCountInt.toString() + " days"
                            }
                        }

                        // Change dates from first/last-full-day to date-departed/returned
                        if (shiftDays && fromDate) {
                            fromDate = subDays(fromDate, 1)
                        }

                        if (shiftDays && toDate) {
                            toDate = addDays(toDate, 1)
                        }

                        return (
                            <tr key={index}>
                                <td style={{}}>{index + 1}</td>
                                <td style={{width: "80px"}}>
                                    <Field.Date
                                        name="FromDate"
                                        value={fromDate && isValid(fromDate) ? format(fromDate, "yyyy-MM-dd") : null}
                                        warning={false}
                                        hideOpener={true}
                                        minDate={periodStart}
                                        maxDate={toDate ? subDays(toDate, 2) : periodEnd}
                                        onChange={(e) => {
                                            // Change date back to first-full-day absent
                                            var value = new UTCDate(e.target.value)

                                            if (shiftDays && value && isValid(value)) {
                                                value = addDays(value, 1)
                                            }

                                            handleAbsenceChange(index, {name: "FromDate", value: value})
                                        }}
                                    />

                                </td>
                                <td style={{width: "80px"}}>

                                    <Field.Date
                                        name="ToDate"
                                        value={toDate && isValid(toDate) ? format(toDate, "yyyy-MM-dd") : null}
                                        warning={false}
                                        hideOpener={true}
                                        minDate={fromDate ? addDays(fromDate, 2) : periodStart}
                                        maxDate={periodEnd}
                                        onChange={(e) => {
                                            // Change date back to last-full-day absent
                                            var value = new UTCDate(e.target.value)

                                            if (shiftDays && value && isValid(value)) {
                                                value = subDays(value, 1)
                                            }

                                            handleAbsenceChange(index, {name: "ToDate", value: value})
                                        }}
                                    />

                                </td>
                                <td style={{width: "70px"}}>

                                    {daysCount ? (
                                        <Help content={daysCount}>
                                            <h3>{daysCount}</h3>
                                            <p>This is the number of <b>whole</b> days absent</p>
                                        </Help>
                                    ) : null}

                                </td>
                                <td style={{minWidth: "80px", maxWidth: "150px"}}>

                                    <Field.Text
                                        name="Purpose"
                                        placeholder="Reason for travelling"
                                        value={rowData.Purpose}
                                        warning={false}
                                        onChange={(fieldOutput: FormFieldOutput) => handleAbsenceChange(index, fieldOutput)} />

                                </td>
                                <td style={{minWidth: "80px", maxWidth: "150px"}}>

                                    <Field.MinimisedLargeListSelect
                                        name="CountriesVisited"
                                        value={rowData.CountriesVisited}
                                        warning={false}
                                        maxValueCount={1}
                                        onChange={(fieldOutput: FormFieldOutput) => handleAbsenceChange(index, fieldOutput)}
                                        options={DisplayDictionary("countries", true)}  />

                                </td>
                                <td style={{width: "70px"}}>

                                    <Field.Select
                                        name="Certainty"
                                        value={rowData.Certainty}
                                        warning={false}
                                        onChange={(fieldOutput: FormFieldOutput) => handleAbsenceChange(index, fieldOutput)}
                                        options={[
                                            {value: "CERTAIN", label: "Certain"},
                                            {value: "DOUBTFUL", label: "Likely"}
                                        ]} />

                                </td>
                                <td style={{width: "15px"}}>
                                    <IconButton style={{padding: "0"}}>
                                        <Icons.X onClick={() => removeAbsence(index)} />
                                    </IconButton>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>

            <Button variant="contained" className="btn btn-sm" onClick={() => addAbsence()}>Add absence</Button>
        </div>
    )
}